<template lang="pug">
  v-row(style="height: 100%")
    v-col(cols="4")
      div(class="side-container")
        v-list-item(class="side-container__element px-0 mb-5")
          v-list-item-content(v-if="!group.full_name")
            v-skeleton-loader(type="sentences")
          v-list-item-content(v-if="group.full_name")
            v-list-item-title {{ group.full_name }}
            v-list-item-subtitle {{ users.length }}
              |  {{ getPluralNoun(users.length, 'участник', 'участника', 'участников') }}
        v-text-field(
          v-model="searchInput"
          class="side-container__element"
          prepend-inner-icon="mdi-magnify"
          label="Поиск"
          rounded filled hide-details
        )
        div(class="side-container__content mb-2")
          v-list.mt-4.d-flex.flex-column.flex-grow-0
            v-fade-transition(group)
              v-list-item(v-for="user in filteredUsers" :key="user.id" style="flex: 0 0 0")
                v-list-item-avatar
                  v-avatar(color="primary" size="34" class="mr-2")
                    span(class="white--text") А
                v-list-item-content
                  v-list-item-title {{ user.fio }}
                  v-list-item-subtitle {{ user.name }}

        //- v-list-item(class="side-container__element px-0 mе-5")
        //-   v-list-item-action
        //-     v-btn(color="primary" rounded) Написать преподавателю
    v-col(cols="8")
      chat-window(:groupId="groupId")

</template>

<script>
import ChatWindow from '@/modules/Chat/components/ChatWindow.vue';
import { getPluralNoun } from '@/utils/string-helpers';

export default {
  name: 'GroupChat',
  components: { ChatWindow },
  data() {
    return {
      searchInput: '',
      users: [],
      group: {},
    };
  },
  computed: {
    groupId() {
      return this.$route.params.id;
    },
    filteredUsers() {
      return this.users.filter((u) => u.fio.toLowerCase().includes(this.searchInput.toLowerCase()));
    },
  },
  mounted() {
    this.getGroupStudents();
    this.getGroupInfo();
  },
  methods: {
    getPluralNoun,
    getGroupStudents() {
      this.$rHandler(
        this.$api.groups.getGroupStudents(this.groupId),
        (r) => {
          this.users = r.data.data;
        },
      );
    },
    getGroupInfo() {
      this.$rHandler(
        this.$api.groups.getGroup(this.groupId),
        (r) => {
          this.group = r.data.data;
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.side-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &__element {
    flex: 0 0 0;
  }

  &__content {
    flex: 1 0 0;
    //background-color: #f9f9f9;
    border-radius: 10px;
    padding: 10px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 4px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: inherit;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background-color: var(--v-primary-base);
      border-radius: 15px;
      height: 4px;
      width: 4px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--v-primary-base);
    }
  }
}

</style>
